import { VEHICLE_DETAILS_ENDPOINT } from "../resources/APP_CONSTANTS";
import { VehicleDetailsResponse } from "../types/apis";

export const getVehicleDetails = async (
  vrm: string,
  mileage: number,
  bearerToken: string,
): Promise<VehicleDetailsResponse> => {
  const valuationServiceUrl = process.env.REACT_APP_VALUATION_SERVICE_URL;

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${bearerToken}`,
    },
    body: JSON.stringify({ vrm: vrm, mileage: mileage }),
  };

  let response;

  try {
    response = await fetch(
      valuationServiceUrl + VEHICLE_DETAILS_ENDPOINT,
      requestOptions,
    );
  } catch (error) {
    throw new Error("Vehicle lookup failed due to fetch" + error);
  }
  const responseJson = await response.json();

  if (response.ok) {
    return {
      make: responseJson.make,
      model: responseJson.model,
      derivative: responseJson.derivative,
      colour: responseJson.colour,
      year: responseJson.regDate.substring(0, 4) as number,
      registrationDate: responseJson.regDate,
      owners: responseJson.owners,
      checks: responseJson.checks,
    } as VehicleDetailsResponse;
  }

  throw new Error("Vehicle lookup failed.");
};
